"use client";

import { ComponentProps } from "react";
import { Separator as RadixSeparator } from "@radix-ui/themes";
import { useIsShopsite } from "@context/DomainContext";
import { joinClassNames } from "@utils/helpers";

interface Props {
  sharedClasses?: string;
  shopsiteClasses?: string;
  whitelabelClasses?: string;
}

export default function Separator({
  className = "",
  sharedClasses = "",
  shopsiteClasses = "",
  whitelabelClasses = "",
  ref,
  ...restProps
}: Props & ComponentProps<typeof RadixSeparator>) {
  const isShopsite = useIsShopsite();

  if (isShopsite) {
    return (
      <div
        className={joinClassNames(
          "border-b",
          className,
          sharedClasses,
          shopsiteClasses
        )}
        ref={ref as React.Ref<HTMLDivElement>}
      />
    );
  }

  return (
    <RadixSeparator
      className={joinClassNames(className, sharedClasses, whitelabelClasses)}
      {...restProps}
      ref={ref}
    />
  );
}
